export interface Character {
  id: number;
  name: string;
  race: string;
  class: string;
  evolvedClass?: string | null;
  evolvedAt?: string | null;
  gender: string;
  skinTone: string;
  baseSprite?: string | null;
  hairSprite?: string | null;
  beardSprite?: string | null;
  vitality: number;
  intelligence: number;
  strength: number;
  dexterity: number;
  constitution: number;
  wisdom: number;
  level: number;
  experience: number;
  maxHP: number;
  currentHP: number;
  actionPoints: number;
  movementPoints: number;
  weaponSlot?: string;
  armorSlot?: string;
  accessorySlot?: string;
  talentPoints?: number; // From TalentPointBalance table
  createdAt: string;
  updatedAt: string;
}

export interface CreateCharacterRequest {
  name: string;
  race: string;
  class: string;
  gender: string;
  skinTone: string;
  hairSprite?: string | null;
  beardSprite?: string | null;
  vitality: number;
  intelligence: number;
  strength: number;
  dexterity: number;
  constitution: number;
  wisdom: number;
}

export interface UpdateCharacterRequest {
  name?: string;
  vitality?: number;
  intelligence?: number;
  strength?: number;
  dexterity?: number;
  constitution?: number;
  wisdom?: number;
  experience?: number;
  currentHP?: number;
  weaponSlot?: string;
  armorSlot?: string;
  accessorySlot?: string;
}

/** Full-replace appearance payload used by both the self-service and admin-override endpoints. */
export interface UpdateCharacterAppearanceRequest {
  gender: string;
  skinTone: string;
  hairSprite?: string | null;
  beardSprite?: string | null;
}

export interface PlayerAppearance {
  gender: string;
  skinTone: string;
  hairSprite: string | null;
  beardSprite: string | null;
}

/**
 * category is 'base' | 'hair' | 'beard' (appearance editor) or one of the equipment
 * overlay folders - 'body' | 'head' | 'legs' | 'boots' | 'gloves' | 'cloak' |
 * 'hand_right' | 'hand_left' (admin equip-sprite picker, GH-41) - left as string
 * since both consumers filter by value rather than exhaustively switching on it.
 */
export interface PlayerSpriteManifestEntry {
  name: string;
  category: string;
  url: string;
}

export const VALID_RACES = ['Human', 'Elf', 'Dwarf', 'Orc', 'Halfling'] as const;
export const VALID_CLASSES = ['Warrior', 'Mage', 'Ranger', 'Rogue', 'Cleric'] as const;
export const VALID_GENDERS = ['Male', 'Female'] as const;
export const SKIN_TONE_PRESETS = ['default', 'pale', 'tan', 'brown', 'dark'] as const;

export type Race = typeof VALID_RACES[number];
export type CharacterClass = typeof VALID_CLASSES[number];
export type Gender = typeof VALID_GENDERS[number];
export type SkinTone = typeof SKIN_TONE_PRESETS[number];